import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../configureStore";
import axios from "axios";
import { API } from "../../../config";
import { setSelectAllSitesFilter } from "../../slices/dashboard/dashboardFilters";

export const fetchDashboardLocationsFilter = createAsyncThunk(
  "dashboardFilters/fetchDashboardLocationsFilter",
  async (_, store) => {
    const { user } = (store.getState() as RootState).Authentication;
    const { locale } = (store.getState() as RootState).LayoutReducer;
    const { locations } = (store.getState() as RootState)
      .DashboardFiltersReducer;
    const token = user?.token ?? "";
    try {
      const response = await axios.get(
        `${API}/users/organization-geo-point?$select[]=name&$limit=10000`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": `${locale}`,
          },
        },
      );

      const { data } = response;

      const locationsResult = data.data.map((loc) => ({
        id: loc.id,
        name: loc.name,
        shared: loc.shared ?? false,
      }));

      const filterLoc = locationsResult.filter((v) => v.shared !== true);

      if (locations.valuesSelected.length === 0) {
        store.dispatch(setSelectAllSitesFilter(filterLoc));
      }
      return filterLoc;
    } catch (error) {
      return store.rejectWithValue(error);
    }
  },
);
